
<div class="card">
    <div class="header d-flex align-items-center">
        <h3 class="me-auto"><span style="color:#0047b2"><i class="fa-solid fa-calendar-days"></i></span> Rostering</h3>
        <button type="button" class="btn btn-primary"><i class="fa-solid fa-file"></i> Save</button>
    </div>
    <div class="card-body">
        <div class="container-fluid">
            <div id="calendar1"></div>
            <br/>
        </div>
    </div>
</div>



